// frontend/klaes-app/src/components/FilmFavs/components/EntryModal.jsx
import { useState } from 'react';
import { BatteryIndicator } from './BatteryIndicator';
import { Chip } from './Chip';
import { TagPicker } from './TagPicker';
import { styles } from '../styles';

export const EntryModal = ({ onSave, onClose, initialData, existingNames, allTags, currentUser, onCreateTag, onDeleteTag }) => {
  const [formData, setFormData] = useState(initialData || {
    name: '',
    description: '',
    type: 'film',
    tags: [],
    rating: 50
  });
  const [error, setError] = useState('');
  const [showTagPicker, setShowTagPicker] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      setError('Bitte einen Namen eingeben');
      return;
    }
    if (!initialData && existingNames.includes(formData.name.toLowerCase())) {
      setError('Ein Eintrag mit diesem Namen existiert bereits!');
      return;
    }
    const rating = formData.rating !== undefined ? formData.rating : 50;
    onSave(formData, rating);
  };

  const addTag = (tag) => {
    if (!formData.tags.find(t => t.name === tag.name)) {
      setFormData({ ...formData, tags: [...formData.tags, tag] });
    }
  };

  const removeTag = (tagToRemove) => {
    setFormData({
      ...formData,
      tags: formData.tags.filter(t => t !== tagToRemove)
    });
  };

  return (
    <>
      <div className={styles.modalOverlay} onClick={onClose}>
        <div className={`${styles.modal} ${styles.modalEntry}`} onClick={(e) => e.stopPropagation()}>
          <h3 style={{ marginBottom: '1.5rem', fontSize: '1.4rem', fontWeight: '600' }}>
            {initialData ? 'Eintrag bearbeiten' : 'Neuen Eintrag hinzufügen'}
          </h3>
          
          <form onSubmit={handleSubmit}>
            <div className={styles.modalFormGroup}>
              <label>Typ</label>
              <select 
                value={formData.type} 
                onChange={(e) => setFormData({...formData, type: e.target.value})}
                className={styles.modalSelect}
              >
                <option value="film">🎬 Film</option>
                <option value="series">📺 Serie</option>
              </select>
            </div>

            <div className={styles.modalFormGroup}>
              <label>Name *</label>
              <input 
                type="text" 
                value={formData.name} 
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
                className={styles.modalInput}
                placeholder="z.B. The Godfather"
              />
            </div>

            <div className={styles.modalFormGroup}>
              <label>Beschreibung</label>
              <textarea 
                value={formData.description} 
                onChange={(e) => setFormData({...formData, description: e.target.value})}
                rows={3}
                className={styles.modalTextarea}
                placeholder="Kurze Beschreibung des Films/der Serie..."
              />
            </div>

            <div className={styles.modalFormGroup}>
              <label>Tags/Chips</label>
              <button type="button" onClick={() => setShowTagPicker(true)} className={styles.modalOpenTagPickerBtn}>
                🏷️ Tags auswählen ({formData.tags.length})
              </button>
              <div className={styles.modalSelectedTags}>
                {formData.tags.map((tag, i) => (
                  <Chip 
                    key={i} 
                    label={tag.name} 
                    category={tag.category}
                    onRemove={() => removeTag(tag)}
                  />
                ))}
              </div>
            </div>

            <div className={styles.modalFormGroup}>
              <label>Deine Bewertung</label>
              <div className={styles.modalRatingContainerInline}>
                <input 
                  type="range" 
                  min="0" 
                  max="100" 
                  step="0.1" 
                  value={formData.rating !== undefined ? formData.rating : 50}
                  onChange={(e) => setFormData({...formData, rating: parseFloat(e.target.value)})}
                  className={styles.compRatingSlider}
                />
                <BatteryIndicator 
                  rating={formData.rating !== undefined ? formData.rating : 50} 
                  isUserRating 
                />
              </div>
            </div>

            {error && <div className={styles.modalError}>{error}</div>}

            <div className={styles.modalEntryButtons}>
              <button type="submit" className={styles.modalSaveBtn}>
                {initialData ? 'Speichern' : 'Erstellen'}
              </button>
              <button type="button" onClick={onClose} className={styles.modalCancelBtn}>Abbrechen</button>
            </div>
          </form>
        </div>
      </div>

      {showTagPicker && (
        <TagPicker 
          onSelectTag={addTag}
          onClose={() => setShowTagPicker(false)}
          existingTags={allTags}
          onCreateTag={onCreateTag}
          onDeleteTag={onDeleteTag}
          selectedTags={formData.tags}
        />
      )}
    </>
  );
};